/* unplugin-vue-components disabled */import { render } from "./filters-dropdown.vue?vue&type=template&id=7e473616&scoped=true"
import script from "./filters-dropdown.vue?vue&type=script&lang=js"
export * from "./filters-dropdown.vue?vue&type=script&lang=js"

import "./filters-dropdown.vue?vue&type=style&index=0&id=7e473616&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e473616"],['__file',"src/components/filters/filters-elements/filters-dropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e473616"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e473616', __exports__)) {
    api.reload('7e473616', __exports__)
  }
  
  module.hot.accept("./filters-dropdown.vue?vue&type=template&id=7e473616&scoped=true", () => {
    api.rerender('7e473616', render)
  })

}


export default __exports__